export default {"src":"/_next/static/media/arrow-left.f71d9abd.svg","height":24,"width":24};